// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ip4gK_wn4Mwy6K4reeuA{flex-direction:column;display:flex}.v_LjRPI01R0NxjwhSaqt{border-bottom:1px solid var(--border-neutral-default);padding:4px}.zlvZ6IwdUy_qfgPWTQXk{justify-content:flex-start}.zlvZ6IwdUy_qfgPWTQXk:hover{background:var(--background-neutral-subtle)!important;color:var(--content-brand-primary)!important}.mnbjVyqxEagztO_jXX3I{text-align:center;padding:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ip4gK_wn4Mwy6K4reeuA`,
	"addAccountWrap": `v_LjRPI01R0NxjwhSaqt`,
	"addAccountButton": `zlvZ6IwdUy_qfgPWTQXk`,
	"notFound": `mnbjVyqxEagztO_jXX3I`
};
export default ___CSS_LOADER_EXPORT___;
